import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styles from './ComingSoonOverlay.module.scss'

export default function ComingSoonOverlay({
  gap = null,
  iconClass = 'fa-regular fa-clock',
  iconSrc = undefined,
  titleId = 'AI_RISK_REPORT.COMING_SOON_OVERLAY.TITLE',
  bodyId = undefined,
  ctaId = undefined,
  ctaHref = undefined,
}) {
  const isLicenseRequired = gap?.reason === 'reason.license_required'
  const resolvedBodyId =
    bodyId ??
    (isLicenseRequired ? 'AI_RISK_REPORT.COMING_SOON_OVERLAY.LICENSE_BODY' : 'AI_RISK_REPORT.COMING_SOON_OVERLAY.BODY')

  return (
    <div className={`${styles.overlay} position-absolute d-grid`}>
      <div className={`${styles.card} d-flex align-items-start`}>
        {iconSrc ? (
          <img className={styles.iconImg} src={iconSrc} alt="" aria-hidden="true" />
        ) : (
          <i className={iconClass} aria-hidden="true" />
        )}
        <div>
          <div className={styles.title}>
            <FormattedMessage id={titleId} />
          </div>
          <div className={styles.body}>
            <FormattedMessage id={resolvedBodyId} />
            {ctaId && ctaHref && (
              <>
                {' '}
                <a className={styles.cta} href={ctaHref} target="_blank" rel="noopener noreferrer">
                  <FormattedMessage id={ctaId} />
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

ComingSoonOverlay.propTypes = {
  gap: PropTypes.shape({ reason: PropTypes.string }),
  iconClass: PropTypes.string,
  iconSrc: PropTypes.string,
  titleId: PropTypes.string,
  bodyId: PropTypes.string,
  ctaId: PropTypes.string,
  ctaHref: PropTypes.string,
}
